(function() {
  'use strict';

  function RemoteProfileBarController(
    $q, $scope, $window, RouterHelper, Organisations, Users, Utils, Features
  ) {
    var ctrl = this;

    ctrl.remoteNavbarCollapsed = $window.innerWidth <= 992;

    ctrl.toggleRemoteNavbar = function() {
      ctrl.remoteNavbarCollapsed = !ctrl.remoteNavbarCollapsed;
    };

    var getMenu = function() {
      return [
        {
          title: 'Summary',
          route: ['/summary', Users.remoteUser]
        },
        {
          title: 'Timeline',
          route: ['/users/edit', Users.remoteUser, 'events', 'list'],
          allowedState: 'active'
        },
        {
          title: 'Goals',
          route: ['/users/edit', Users.remoteUser, 'goals'],
          allowedState: 'active'
        },
        {
          title: 'Reports',
          route: ['/users/edit', Users.remoteUser, 'reports'],
          allowedState: 'active',
          requireFeature: 'reporting'
        },
        {
          title: 'Files',
          route: ['/users/edit', Users.remoteUser, 'files'],
          allowedState: 'active'
        }
      ];
    };

    var getLinks = function() {
      if (_.isEmpty(ctrl.remoteProfile)) {
        ctrl.menu = [];
        return;
      }

      var menu = getMenu();
      menu = menu.filter(function(item) {
        return item.allowedState === undefined || ctrl.remoteProfile.state === item.allowedState;
      });

      var checkPermission = function(link) {
        var promise;
        if (link.requireFeature) {
          promise = Features.isEnabled(link.requireFeature);
        } else {
          promise = $q.when(true);
        }

        return promise;
      };

      return Utils.asyncFilter(menu, checkPermission)
        .then(function(menu) {
          ctrl.menu = menu;
        })
        .then(function() {
          return Organisations.getListOptions();
        })
        .then(function(options) {
          var timeline = _.find(ctrl.menu, { title: 'Timeline' });
          var goals = _.find(ctrl.menu, { title: 'Goals' });

          if (!_.isUndefined(timeline)) {
            if ((options['epf.events.index'] || {}).sections === undefined) {
              _.assignIn(timeline, {
                route: ['/users/edit', ctrl.remoteProfile.username, 'events', 'list']
              });

              delete timeline.links;
              return;
            }

            timeline.links = _.chain(options['epf.events.index'].sections)
              .map(function(filter) {
                if (filter.allowedRoles && filter.allowedRoles.length > 0) {
                  if (_.intersection(ctrl.remoteProfile.roles, filter.allowedRoles).length === 0) {
                    return undefined;
                  }
                }
                return {
                  title: filter.name,
                  route: ['/users/edit', ctrl.remoteProfile.username, 'events', 'list', filter.id]
                };
              })
              .filter(function(item) {
                return item !== undefined;
              })
              .value();

            delete timeline.state;
            delete timeline.stateOptions;
            delete timeline.route;
          }

          if (!_.isUndefined(goals)) {
            if ((options['epf.goals.index'] || {}).sections === undefined) {
              _.assignIn(goals, {
                route: ['/users/edit', ctrl.remoteProfile.username, 'goals']
              });

              delete goals.links;
              return;
            }

            goals.links = _.chain(options['epf.goals.index'].sections)
              .map(function(filter) {
                if (filter.allowedRoles && filter.allowedRoles.length > 0) {
                  if (_.intersection(ctrl.remoteProfile.roles, filter.allowedRoles).length === 0) {
                    return undefined;
                  }
                }
                return {
                  title: filter.name,
                  route: ['/users/edit', ctrl.remoteProfile.username, 'goals', filter.id]
                };
              })
              .filter(function(item) {
                return item !== undefined;
              })
              .value();


            delete goals.state;
            delete goals.stateOptions;
            delete goals.route;
          }
        });
    };

    function updateUser(value) {
      ctrl.remoteUser = value;
      if (!value) {
        delete ctrl.remoteProfile;
        return;
      }

      Users.find(value, { forceRemote: true })
        .then(function(doc) {
          // This  is a hack, that if you query remote user via API
          // it always sets the cached profile on it so that you don't have to query/compute it
          // because it has to be done via api as you don't have direct access to their timeline
          if (_.isUndefined(doc._tmp_cache)) {
            return;
          }

          // Set the remote profile data
          ctrl.remoteProfile = _.assign(
            {},
            doc,
            {
              roles: _.filter(doc.roles || [], function(role) {
                return !_.startsWith(role, 'system:');
              })
            },
            {
              relations: doc._tmp_cache.profile.relations,
              dependent: doc._tmp_cache.profile.user_dependent
            }
          );

          getLinks();
        });
    }

    $scope.$on('KZRemoteUserChanged', function() {
      updateUser(Users.remoteUser);
    });

    $scope.$watch(function() {
      return Users.remoteUser;
    }, function(value) {
      updateUser(value);
    });

    var setProfileClass = function() {
      const currentState = RouterHelper.getState();
      $scope.profileViewActive = currentState === 'dashboard.profile.view';
    };

    setProfileClass();
    RouterHelper.onSuccess(function() {
      setProfileClass();
    });
  }

  RemoteProfileBarController.$inject = [
    '$q',
    '$scope',
    '$window',
    'RouterHelperService',
    'OrganisationsService',
    'UsersService',
    'UtilsService',
    'FeaturesService'
  ];

  function RemoteProfileBar(Users) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/layout/header/remote-profile-bar.html',
      controller: RemoteProfileBarController,
      controllerAs: 'remoteProfileBarCtrl',
      link: function($scope) {
        var bodyEl = angular.element(document.getElementsByTagName('body')[0]);
        var remoteProfileClass = 'remote-profile';

        $scope.$watch(function() {
          return Users.remoteUser;
        }, function(value) {
          if (_.isEmpty(value)) {
            bodyEl.removeClass(remoteProfileClass);
          } else {
            bodyEl.addClass(remoteProfileClass);
          }
        });
      }
    };
  }

  RemoteProfileBar.$inject = ['UsersService'];

  angular.module('kzHeaderCard')
    .directive('kzRemoteProfileBar', RemoteProfileBar);
})();
